<!--
 * @Autor: Baowang
 * @Date: 2024-11-07 09:13:28
 * @pageName: 主页面入口
 * @LastEditTime: 2024-11-07 10:38:34
-->
<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>

export default {
  name: 'App',
  mounted() {
    this.getLogo()
    // setTimeout(() => {
    //   var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
    //   link.rel = 'shortcut icon';
    //   link.href = 'https://assets3.pgyer.com/static-20250828/assets/img/default-icon.png'
    //   document.getElementsByTagName('head')[0].appendChild(link);
    //   document.title = "草拟吗"
    // }, 300)
  },
  methods: {
    getLogo() {
      this.$api({
        url: '/api/index/customer_service',
        method: 'POST',
      }).then(res => {
        console.log(res)
        var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.rel = 'shortcut icon';
        link.href = res.data.logo
        document.getElementsByTagName('head')[0].appendChild(link);
        document.title = res.data.platform_name
      })
    },
  }
};
</script>

<style lang="less">
@import "@/utils/css/base.css";

#app {
  caret-color: transparent;
}

.toptitle {
  background: url('@/assets/titlebg.png') no-repeat 0 0/100% 100%;
  width: 415px;
  height: 50px;
  line-height: 50px;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: bold;
  font-size: 15px;
  text-align: left;
  padding-left: 20px;
  color: #FFFFFF;
  font-style: normal;
  text-transform: none;
}

.topone {
  width: 25%;
  // height: calc((100vh - 100px) /2);
  height: calc(50vh - 50px);
  margin-right: 30px;
  display: flex;
  flex-direction: column;

  .datebox {
    line-height: 32px;
    padding: 0 10px;
    font-size: 16px;
    width: 126px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 33px;
    background: linear-gradient(180deg, #041852 0%, rgba(46, 104, 227, 0.23) 100%);

  }




  &:first-child {
    margin-left: 30px;
  }
}

.line {
  // opacity: 0.4;
  border-image: linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, .4), rgba(255, 255, 255, 0)) 1 1;
}

.point {
  cursor: pointer;
}
</style>
